<template>
  <div>
    <el-select :value="value" :placeholder="$t('table.role')" value-key="id" :size="size" @input="change($event)">
      <el-option label="----------" :value="emptyValue" />
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
    </el-select>
  </div>
</template>

<script>

import { fetchRoleList } from '@/api/role'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: []
    }
  },
  created () {
    fetchRoleList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchRoleList({limit: 0}).then((res) => {
        this.options = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/RoleSelect/index.vue